// @TODO: delete theme.feedbackForm.popper (just use theme.popover)
const addFeedbackFormTheme = feedbackFormTheme => theme => {
  var _theme$feedbackForm, _theme$popover, _theme$popover2, _theme$feedbackForm$p, _theme$feedbackForm2, _feedbackFormTheme$po;
  const newTheme = {
    ...theme,
    feedbackForm: {
      ...((_theme$feedbackForm = theme === null || theme === void 0 ? void 0 : theme.feedbackForm) !== null && _theme$feedbackForm !== void 0 ? _theme$feedbackForm : {}),
      ...(feedbackFormTheme !== null && feedbackFormTheme !== void 0 ? feedbackFormTheme : {}),
      popper: {
        portalElementId: theme === null || theme === void 0 || (_theme$popover = theme.popover) === null || _theme$popover === void 0 ? void 0 : _theme$popover.portalElementId,
        zIndex: theme === null || theme === void 0 || (_theme$popover2 = theme.popover) === null || _theme$popover2 === void 0 ? void 0 : _theme$popover2.zIndex,
        ...((_theme$feedbackForm$p = theme === null || theme === void 0 || (_theme$feedbackForm2 = theme.feedbackForm) === null || _theme$feedbackForm2 === void 0 ? void 0 : _theme$feedbackForm2.popper) !== null && _theme$feedbackForm$p !== void 0 ? _theme$feedbackForm$p : {}),
        ...((_feedbackFormTheme$po = feedbackFormTheme === null || feedbackFormTheme === void 0 ? void 0 : feedbackFormTheme.popper) !== null && _feedbackFormTheme$po !== void 0 ? _feedbackFormTheme$po : {})
      }
    }
  };
  newTheme.popover.portalElementId = newTheme.feedbackForm.popper.portalElementId;
  newTheme.popover.zIndex = Number(newTheme.feedbackForm.popper.zIndex);
  return newTheme;
};

export { addFeedbackFormTheme as a };
//# sourceMappingURL=addFeedbackFormTheme-BKv0OWWq.js.map
